import React from 'react';
import { Link } from 'react-router-dom';
import { Brain, Phone, Mail, MapPin, Facebook, Instagram, Globe, Linkedin, Youtube } from 'lucide-react';
import { doctorInfo } from '../../data/content';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Info */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="bg-blue-600 p-2 rounded-lg text-white">
                <Brain size={24} />
              </div>
              <span className="font-bold text-xl">{doctorInfo.name}</span>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Dedicated to providing world-class neurological care with a patient-first approach. 
              Your brain health is our priority.
            </p>
            <div className="flex gap-4">
              {/* Social Links */}
              <a href={doctorInfo.social.linkedin} target="_blank" rel="noreferrer" aria-label="Visit our LinkedIn profile" className="bg-gray-800 p-2 rounded-full hover:bg-blue-700 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href={doctorInfo.social.instagram} target="_blank" rel="noreferrer" aria-label="Visit our Instagram profile" className="bg-gray-800 p-2 rounded-full hover:bg-pink-600 transition-colors">
                <Instagram size={20} />
              </a>
              <a href={doctorInfo.social.youtube} target="_blank" rel="noreferrer" aria-label="Visit our YouTube channel" className="bg-gray-800 p-2 rounded-full hover:bg-red-600 transition-colors">
                <Youtube size={20} />
              </a>
              {/* <a href={doctorInfo.social.google} target="_blank" rel="noreferrer" className="bg-gray-800 p-2 rounded-full hover:bg-green-600 transition-colors">
                <Globe size={20} />
              </a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 border-b border-gray-800 pb-2 inline-block">Quick Links</h3>
            <ul className="space-y-3">
              {['Home', 'About', 'Services', 'Media', 'Contact'].map((item) => (
                <li key={item}>
                  <Link to={`/${item.toLowerCase() === 'home' ? '' : item.toLowerCase()}`} className="text-gray-300 hover:text-blue-400 transition-colors flex items-center gap-2">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6 border-b border-gray-800 pb-2 inline-block">Our Services</h3>
            <ul className="space-y-3">
              {[
                { name: 'Stroke Management', path: '/services/stroke-management' },
                { name: 'Headache & Migraine', path: '/services/headache-migraine' },
                { name: 'Epilepsy Care', path: '/services/epilepsy-care' },
                { name: 'Vertigo Treatment', path: '/services/vertigo-balance' },
                { name: 'Neuropathy', path: '/services/neuropathy-muscle' }
              ].map((item) => (
                <li key={item.name}>
                  <Link to={item.path} className="text-gray-300 hover:text-blue-400 transition-colors flex items-center gap-2">
                    <span className="w-1.5 h-1.5 bg-teal-500 rounded-full"></span>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 border-b border-gray-800 pb-2 inline-block">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-gray-300">
                <MapPin className="text-blue-500 shrink-0 mt-1" size={20} />
                <span>{doctorInfo.clinic},<br />{doctorInfo.location}</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300">
                <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="w-5 h-5 shrink-0" />
                <a href={doctorInfo.social.whatsapp} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Chat on WhatsApp</a>
              </li>
              <li className="flex items-center gap-3 text-gray-300">
                <Mail className="text-blue-500 shrink-0" size={20} />
                <a href={`mailto:${doctorInfo.email}`} className="hover:text-white transition-colors">{doctorInfo.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} {doctorInfo.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
